import React, { useState, useEffect } from "react";

import Main from './components/emailCreator/main'


const emailCreatorView = () => {

  return (<Main />)
  
}

export default emailCreatorView;
